import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import D2TN from './d2TN';
import K2TN from './k2TN';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function K1TN({initiallyDisableKeypress}) {
  const [value, setValue] = useState(10);
  const {setDisableMenu, onComponent} = useContext(MenuContext);
  const {t, i18n} = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  const onRightHold = useCallback(() => {
    setDisableMenu(true);
    onComponent(<K2TN initiallyDisableKeypress />);
    setTimeout(() => setDisableMenu(false), 500);
  }, [value]);

  return (
    <NumberView
      chars={numbers}
      focus={7}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={0}
      defaultKey4={0}
      defaultKey5={0}
      defaultKey6={0}
      defaultKey7={3}
      defaultKey8={2}
      defaultKey9={2}
      defaultKey10={2}
      defaultKey11={12}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={() => onComponent(<D2TN />)}
      title={t('channelConfig.a8')}
      caption={t('channelConfig.a9')}
      left={t('setDeviceTag.a3')}
      right={t('setDeviceTag.a4')}
      initiallyDisableKeypress={initiallyDisableKeypress}
    />
  );
}

export default K1TN;
